import { render, staticRenderFns } from "./MatchInsights.vue?vue&type=template&id=3776d261&scoped=true"
import script from "./MatchInsights.vue?vue&type=script&lang=js"
export * from "./MatchInsights.vue?vue&type=script&lang=js"
import style0 from "./MatchInsights.vue?vue&type=style&index=0&id=3776d261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776d261",
  null
  
)

export default component.exports